import { stimulusApp } from './application'
import ModalPortalController from './modal_portal_controller.js'
import TurboModalController from './turbo_modal_controller.js'
import ImageViewerController from './image_viewer_controller.js'
import CountdownController from './countdown_controller.js'
import ReloadableFrameController from './reloadable_frame_controller.js'
import CarouselStimulusController from './carousel_stimulus_controller.js'
import BonusCodeController from './bonus_code_controller.js'
import SubscriptionSimulatorController from './subscription_simulator_controller.js'
import ChartController from './chart_controller.js'
import SafeClickHandlerController from './safe_click_handler_controller.js'
import ToggleSidebarController from './toggle_sidebar_controller.js'
import SubscriptionController from './subscription_controller.js'
import AdminPrepareSyncWithAircapFormController from './admin_prepare_sync_with_aircap_form_controller.js'
import InvestRobotController from './invest_robot_controller.js'
import AdminProjectFormController from './admin_project_form_controller.js'
import AdminActualityRecipientsController from './admin_actuality_recipients_controller.js'
import ClipboardController from './clipboard_controller.js'
import ShareLinkController from './share_link_controller.js'
import InputCurrencyController from './input_currency_controller.js'
import SignatureController from './signature_controller.js'
import PopoverController from './popover_controller.js'
import GoogleFirebaseAnalyticsSetupController from './google_firebase_analytics_setup_controller.js'
import OnesignalPushNotificationSetupController from './onesignal_push_notification_setup_controller.js'
import NewUboFormController from './new_ubo_form_controller.js'
import NestedFormController from './nested_form_controller.js'
import Select2Controller from './select2_controller.js'
import NewUboSignatureController from './new_ubo_signature_controller.js'
import FormLoaderController from './form_loader_controller.js'
import CreditAccountModalController from './credit_account_modal_controller.js'
import PowensWebviewController from './powens_webview_controller.js'
import AnimateUnderlineController from './animate_underline_controller.js'
import LineCropController from './line_crop_controller.js'
import ProjectImagesController from './project_images_controller.js'
import RangeSliderController from './range_slider_controller.js'
import DashboardChartsRebrandingController from './dashboard_charts_rebranding_controller.js'
import DashboardChartsRentalController from './dashboard_charts_rental_controller.js'
import DashboardOngoingSwitchController from './dashboard_ongoing_switch_controller.js'
import SimulationToggleController from './simulation_toggle_controller.js'
import RebrandingInputCurrencyController from './rebranding_input_currency_controller.js'
import RebrandingCreditAccountModalController from './rebranding_credit_account_modal_controller.js'
import FilterAndLoadMoreController from './filter_and_load_more_controller.js'
import ChartRebrandingController from './chart_rebranding_controller.js'
import RebrandingUsersConfigurationsTermsFormController from './rebranding/users/configurations/terms_form_controller'
import RebrandingKycDocumentFormController from './rebranding/kyc_document_form_controller.js'
import RebrandingRegistrationController from './rebranding/registration_controller.js'
import CheckAllInputFilledController from './rebranding/check_all_input_filled_controller.js'
import AutoSubmitFormController from './auto_submit_form_controller.js'
import TermDetailsNavigationController from './term_details_navigation_controller.js'
import FileFieldRebrandingController from './rebranding/file_field_rebranding_controller.js'
import AuthenticatorCodeController from './authenticator_code_controller.js'
import TwoFactorController from './two_factor_controller.js'
import ApiAutocompleteController from './api_autocomplete_controller.js'
import BirthInformationController from './birth_information_controller.js'
import AppInstallBannerController from './app_install_banner_controller.js'
import PlanInvestmentController from './plan_investment_controller.js'
import BannerController from './banner_controller.js'
import SelectDeliveryMethodController from './select_delivery_method_controller.js'
import IframeScaController from './iframe_sca_controller.js'
import ModalController from './modal_controller.js'
import PasswordStrengthController from './password_strength_controller.js'
import PasswordVisibilityController from './password_visibility_controller.js'
import UserRegistrationController from './user_registration_controller.js'
import BiometricAuthSetupController from './biometric_auth_setup_controller.js'
import BiometricAuthController from './biometric_auth_controller.js'
import DirectCardPayinController from './direct_card_payin_controller.js'
import DesignPageController from './design_page_controller.js'
import SellingOfferFormController from './selling_offer_form_controller.js'
import StickyBarSpacerController from './sticky_bar_spacer_controller.js'
import PurchaseCheckoutController from './purchase_checkout_controller.js'
import WaitingListPositionController from './waiting_list_position_controller.js'
import UserMenuController from './user_menu_controller.js'
import TriggerActualityTabController from './trigger_actuality_tab_controller.js'
import ProfileSectionsController from './profile_sections_controller.js'
import CrispChatController from './crisp_chat_controller.js'

stimulusApp.register('modal-portal', ModalPortalController)
stimulusApp.register('turbo-modal', TurboModalController)
stimulusApp.register('image-viewer', ImageViewerController)
stimulusApp.register('countdown', CountdownController)
stimulusApp.register('reloadable-frame', ReloadableFrameController)
stimulusApp.register('carousel-stimulus', CarouselStimulusController)
stimulusApp.register('bonus-code', BonusCodeController)
stimulusApp.register('subscription-simulator', SubscriptionSimulatorController)
stimulusApp.register('chart', ChartController)
stimulusApp.register('safe-click-handler', SafeClickHandlerController)
stimulusApp.register('toggle-sidebar', ToggleSidebarController)
stimulusApp.register('subscription', SubscriptionController)
stimulusApp.register('admin-prepare-sync-with-aircap-form', AdminPrepareSyncWithAircapFormController)
stimulusApp.register('invest-robot', InvestRobotController)
stimulusApp.register('admin-project-form', AdminProjectFormController)
stimulusApp.register('admin-actuality-recipients', AdminActualityRecipientsController)
stimulusApp.register('clipboard', ClipboardController)
stimulusApp.register('share-link', ShareLinkController)
stimulusApp.register('input-currency', InputCurrencyController)
stimulusApp.register('signature', SignatureController)
stimulusApp.register('popover', PopoverController)
stimulusApp.register('google-firebase-analytics-setup', GoogleFirebaseAnalyticsSetupController)
stimulusApp.register('onesignal-push-notification-setup', OnesignalPushNotificationSetupController)
stimulusApp.register('new-ubo-form', NewUboFormController)
stimulusApp.register('nested-form', NestedFormController)
stimulusApp.register('select2', Select2Controller)
stimulusApp.register('new-ubo-signature', NewUboSignatureController)
stimulusApp.register('form-loader', FormLoaderController)
stimulusApp.register('credit-account-modal', CreditAccountModalController)
stimulusApp.register('powens-webview', PowensWebviewController)
stimulusApp.register('animate-underline', AnimateUnderlineController)
stimulusApp.register('line-crop', LineCropController)
stimulusApp.register('project-images', ProjectImagesController)
stimulusApp.register('range-slider', RangeSliderController)
stimulusApp.register('dashboard-charts-rebranding', DashboardChartsRebrandingController)
stimulusApp.register('dashboard-charts-rental', DashboardChartsRentalController)
stimulusApp.register('dashboard-ongoing-switch', DashboardOngoingSwitchController)
stimulusApp.register('simulation-toggle', SimulationToggleController)
stimulusApp.register('rebranding-input-currency', RebrandingInputCurrencyController)
stimulusApp.register('rebranding-credit-account-modal', RebrandingCreditAccountModalController)
stimulusApp.register('filter-and-load-more', FilterAndLoadMoreController)
stimulusApp.register('chart-rebranding', ChartRebrandingController)
stimulusApp.register('rebranding-users-configurations-terms-form', RebrandingUsersConfigurationsTermsFormController)
stimulusApp.register('rebranding-kyc-document-form', RebrandingKycDocumentFormController)
stimulusApp.register('rebranding-registration', RebrandingRegistrationController)
stimulusApp.register('check-all-input-filled', CheckAllInputFilledController)
stimulusApp.register('auto-submit-form', AutoSubmitFormController)
stimulusApp.register('term-details-navigation', TermDetailsNavigationController)
stimulusApp.register('file-field-rebranding', FileFieldRebrandingController)
stimulusApp.register('authenticator-code', AuthenticatorCodeController)
stimulusApp.register('two-factor', TwoFactorController)
stimulusApp.register('api-autocomplete', ApiAutocompleteController)
stimulusApp.register('birth-information', BirthInformationController)
stimulusApp.register('app-install-banner', AppInstallBannerController)
stimulusApp.register('plan-investment', PlanInvestmentController)
stimulusApp.register('banner', BannerController)
stimulusApp.register('select-delivery-method', SelectDeliveryMethodController)
stimulusApp.register('iframe-sca', IframeScaController)
stimulusApp.register('modal', ModalController)
stimulusApp.register('password-strength', PasswordStrengthController)
stimulusApp.register('password-visibility', PasswordVisibilityController)
stimulusApp.register('user-registration', UserRegistrationController)
stimulusApp.register('biometric-auth-setup', BiometricAuthSetupController)
stimulusApp.register('biometric-auth', BiometricAuthController)
stimulusApp.register('direct-card-payin', DirectCardPayinController)
stimulusApp.register('design-page', DesignPageController)
stimulusApp.register('selling-offer-form', SellingOfferFormController)
stimulusApp.register('sticky-bar-spacer', StickyBarSpacerController)
stimulusApp.register('purchase-checkout', PurchaseCheckoutController)
stimulusApp.register('waiting-list-position', WaitingListPositionController)
stimulusApp.register('user-menu', UserMenuController)
stimulusApp.register('trigger-actuality-tab', TriggerActualityTabController)
stimulusApp.register('profile-sections', ProfileSectionsController)
stimulusApp.register('crisp-chat', CrispChatController)
